/* tslint:disable:jsx-no-lambda */
import '@ta-interaktiv/semantic-ui/semantic/dist/components/dropdown.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/transition.css'
import React, { FunctionComponent, SyntheticEvent } from 'react'
import { Dropdown } from 'semantic-ui-react'
import './styles.scss'

export interface IDropdown {
  currentValue: string | undefined
  placeholderText?: string
  options: { text: string; value: string | undefined }[]
  changeHandler: (value: string | undefined, event?: SyntheticEvent) => void
}

export const DesktopDropdown: FunctionComponent<IDropdown> = ({
  currentValue = '',
  options,
  changeHandler,
  placeholderText = 'Auswählen …'
}: IDropdown) => (
  <Dropdown
    scrolling={true}
    selection={true}
    fluid={true}
    clearable={true}
    value={currentValue}
    onChange={(e, { value }) => changeHandler(value as string, e)}
    options={options}
    placeholder={placeholderText}
  />
)

export const MobileDropdown: FunctionComponent<IDropdown> = ({
  currentValue = '',
  options,
  changeHandler,
  placeholderText = 'Auswählen …'
}: IDropdown) => {
  options.push({ text: placeholderText, value: '' })

  return (
    <select
      onChange={e => changeHandler(e.currentTarget.value, e)}
      value={currentValue}
    >
      {options.map(option => (
        <option key={option.text} value={option.value}>
          {option.text}
        </option>
      ))}
    </select>
  )
}
